import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
axios.defaults.baseURL = process.env.NODE_ENV==="production"?process.env.REACT_APP_API:process.env.REACT_APP_LIVEMODE==="live"?process.env.REACT_APP_API:process.env.REACT_APP_API_TEST;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <App />
  </React.Fragment>
);
reportWebVitals();
